import { render } from "./AddProductSubcategory.vue?vue&type=template&id=f3715c3a&scoped=true"
import script from "./AddProductSubcategory.vue?vue&type=script&lang=js"
export * from "./AddProductSubcategory.vue?vue&type=script&lang=js"

import "./AddProductSubcategory.vue?vue&type=style&index=0&id=f3715c3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3715c3a"]])

export default __exports__